/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Status_Booked6Inputs */

const en_application_status_booked6 = /** @type {(inputs: Application_Status_Booked6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked`)
};

const de_application_status_booked6 = /** @type {(inputs: Application_Status_Booked6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebucht`)
};

/**
* | output |
* | --- |
* | "Booked" |
*
* @param {Application_Status_Booked6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const application_status_booked6 = /** @type {((inputs?: Application_Status_Booked6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Status_Booked6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_status_booked6(inputs)
	return en_application_status_booked6(inputs)
});
export { application_status_booked6 as "application_status_BOOKED" }